var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333252C10.6819 0.333252 13.6666 3.31859 13.6666 6.99992C13.6666 10.6813 10.6819 13.6666 6.99992 13.6666C3.31792 13.6666 0.333252 10.6813 0.333252 6.99992C0.333252 3.31859 3.31792 0.333252 6.99992 0.333252ZM7.00112 9.0024C6.63342 9.0024 6.33534 9.30048 6.33534 9.66818C6.33534 10.0359 6.63342 10.334 7.00112 10.334C7.36882 10.334 7.66689 10.0359 7.66689 9.66818C7.66689 9.30048 7.36882 9.0024 7.00112 9.0024ZM6.99968 3.66659C6.65779 3.66671 6.3761 3.92417 6.33771 4.25574L6.33325 4.33349L6.33445 7.66741L6.33897 7.74516C6.37759 8.0767 6.65947 8.33396 7.00136 8.33384C7.34325 8.33372 7.62494 8.07625 7.66333 7.74468L7.66779 7.66693L7.66659 4.33301L7.66207 4.25527C7.62344 3.92372 7.34157 3.66646 6.99968 3.66659Z",
    fill: "#F7685B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.a6bce0e614df513bd0c1af3a2065033a.svg";
export { ForwardRef as ReactComponent };